export default __webpack_public_path__ + "static/img-social-contributions-heading-d4abea7d885259cbb2300e23d04ba7c3.png";